import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../core/i18n';
import { PrincipalConfigurationDirectiveModule } from '../../directives';
import { PipesModule } from '../../pipes';
import { BadgeModule } from '../badge';
import { NotificationModule } from '../notification';
import { ArticleDetailsComponent } from './article-details/article-details.component';
import { ConsignmentStockArticleStockInfoModule } from './consignment-stock-article-stock-info/consignment-stock-article-stock-info.module';
import { DetailedStockInfoComponent } from './detailed-stock-info.component';
import { ExtendedDetailedStockInfoModule } from './extended-detailed-stock-info/extended-detailed-stock-info.module';
import { VolumeDiscountTableComponent } from './volume-discount-table/volume-discount-table.component';

@NgModule({
  imports: [
    CommonModule,
    ExtendedDetailedStockInfoModule,
    ConsignmentStockArticleStockInfoModule,
    VolumeDiscountTableComponent,
    ArticleDetailsComponent,
    I18nModule,
    NzIconModule,
    PipesModule,
    BadgeModule,
    NotificationModule,
    NgbTooltipModule,
    PrincipalConfigurationDirectiveModule,
  ],
  declarations: [DetailedStockInfoComponent],
  exports: [DetailedStockInfoComponent],
})
export class DetailedStockInfoModule {}
